import React, { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { getGuestCartId } from "modules/Cart/actions";
import { Spinner } from "components/Spinner";
import { List } from "./components";

class Cart extends Component {
  handleEmptyCartClick = () => {
    this.props.getGuestCartId();
    window.alert(
      "Cart has been emptied. You will now be redirected to homepage."
    );
    document.location.href = "/";
  };

  render() {
    const { cartProducts, cartLoading, cartId, cartPrice } = this.props;
    const { handleEmptyCartClick } = this;
    return (
      <div>
        <div className="pageWrapper">
          <div className="cartPage">
            <div className="cartPage__title">
              <h1>Shopping Cart</h1>
            </div>
            {cartProducts.length > 0 ? (
              <List
                cartProducts={cartProducts}
                cartPrice={cartPrice}
                handleEmptyCartClick={handleEmptyCartClick}
                cartId={cartId}
              />
            ) : (
              <div className="empty">
                There are no products in the cart.{" "}
                <Link to="/catalog/3/1">Continue Shopping</Link>.
              </div>
            )}
          </div>
        </div>
        {cartLoading ? <Spinner /> : null}
      </div>
    );
  }
}

const mapStateToProps = state => {
  const { cartProducts, cartPrice, cartQty, cartId } = state.cartReducer;
  const { cartLoading } = state.animationsReducer;

  return {
    cartId: cartId,
    cartProducts: cartProducts,
    cartPrice: cartPrice,
    cartQty: cartQty,
    cartLoading: cartLoading
  };
};

const mapDispatchToProps = dispatch => {
  return {
    getGuestCartId: () => dispatch(getGuestCartId())
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Cart);



// WEBPACK FOOTER //
// ./src/modules/Cart/Cart.jsx